import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: frankgrinaert
 * id 643EF8E3-148D-4858-85C6-A965822B74CF
 * name archive-arrow-up-outline
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-arrow-up-outline.svg
 * tags
 */
export const ArchiveArrowUpOutlineIcon = createSvgIcon(<><path d="M20 21H4V10H6V19H18V10H20V21M3 3H21V9H3V3M5 5V7H19V5M10.5 17V14H8L12 10L16 14H13.5V17" /></>, 'ArchiveArrowUpOutlineIcon');
export default ArchiveArrowUpOutlineIcon